import React from "react";
import Link from "next/link";
import { BreadcrumbArrow } from "./breadcrumb-arrow";
export const Breadcrumbs = ({ category, categories, slugs }) => {
  return (
    <ul className={`flex flex-row items-center space-x-4`}>
      <li>
        <Link href={`/`}>
          <a className={`hover:underline`}>Home</a>
        </Link>
      </li>
      {slugs.map((slug, key) => {
        const segments = slugs.slice(0, key + 1);
        return (
          <li key={key}>
            <span className={`flex flex-row items-center space-x-4`}>
              <BreadcrumbArrow />
              {slug === category?.attributes?.slug && (
                <span className={``}>{category?.attributes?.name}</span>
              )}
              {slug !== category?.attributes?.slug && (
                <Link href={`/category/${segments.join("/")}`}>
                  <a className={`hover:underline`}>
                    {
                      categories?.find(
                        (category) => category.attributes.slug === slug
                      )?.attributes?.name
                    }
                  </a>
                </Link>
              )}
            </span>
          </li>
        );
      })}
    </ul>
  );
};
